import React from 'react';

const InfoCard = ({ head, text }) => (
  <div style={{ background:'#fff', borderRadius:14, padding:'16px', marginBottom:14, border:'1px solid #e2e8f0', boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}>
    <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:8 }}>
      <div style={{ width:3, height:16, borderRadius:2, background:'#f59e0b', flexShrink:0 }}/>
      <span style={{ fontSize:14, fontWeight:800, color:'#0f172a' }}>{head}</span>
    </div>
    <p style={{ margin:0, fontSize:13, lineHeight:1.8, color:'#475569', whiteSpace:'pre-line' }}>{text}</p>
  </div>
);

export default InfoCard;
